module.exports = __webpack_public_path__ + "img/Sven.98524816.png";